import { initialize } from 'redux-form'
import flowRight from 'lodash/flowRight'
import { LKDate } from 'loankeeper-common/helpers/Date'
import transformProps from 'loankeeper-common/containers/transformProps'

import { LKModalContainer } from '../../shared/LKModal'
// import withFetcher from '../../shared/containers/withFetcher'

import { FORM_NAME } from './constants'
import { reduxFormContainer } from './containers'
import commonContainers from '../containers/common'
import withFetcherHoc from 'src/features/shared/containers/withFetcherNew'
import { accEntryOrderInitialFields, destroyAccEntryInitialFields } from 'src/store/accEntry'

export default flowRight(
  LKModalContainer(),

  commonContainers,

  transformProps((props) => ({
    ...props,
    APIParams: {
      EntryID: props.params.ID,
      HashSum_EntryID_: props.params.hash,
    },
  })),

  //@ts-ignore
  // withFetcher({
  //   fetcherName: 'OrderAddFetchInitialFields',
  //   APICall: Order.details,
  //   withLoading: true,
  //   getDataFromResponse: ({ Data }) => ({ initialData: Data }),
  //   completeAction: ({ Data }, props) => initialize(FORM_NAME, {
  //       EntryID: props.copyOrder ? undefined : Data.ID,
  //       HashSum_EntryID_: props.copyOrder ? undefined : Data.HashSum_EntryID_,
  //       DocNo: props.copyOrder ? '' : Data.DocNo,
  //       CCY: Data.CCY,
  //       DocDate: props.copyOrder ? props.OpenDay : LKDate.from(Data.DocDate).toString(),
  //       DebitAccNo: Data.DebitAcc,
  //       DebitAccID: Data.DebitAccID,
  //       DebitAccHash: Data.HashSum_DebitAccID_,
  //       DebitTitleUNI: Data.DebitAccTitleUNI,
  //       DebitAccBalance: Data.BalanceDebit,
  //       CreditAccNo: Data.CreditAcc,
  //       CreditAccID: Data.CreditAccID,
  //       CreditAccHash: Data.HashSum_CreditAccID_,
  //       CreditTitleUNI: Data.CreditAccTitleUNI,
  //       CreditAccBalance: Data.BalanceCredit,
  //       Amount: props.copyOrder ? 0 : Data.Amount,
  //       OpCodeID: Data.OpCodeID,
  //       Comment: Data.Comment,
  //       action: props.copyOrder ? 'add' : 'edit', // request action to edit order
  //     }),
  // }),

  //UPDATED API REQUEST acc_entry_view_api.php
  //@ts-ignore
  withFetcherHoc({
    fetcherName: 'accEntryInitialFields',
    APICall: accEntryOrderInitialFields,
    withLoading: true,
    getDataFromResponse: (data) => ({ initialData: data }),
    completeAction: (data, props) =>
      initialize(FORM_NAME, {
        EntryID: props.copyOrder ? undefined : data.ID,
        HashSum_EntryID_: props.copyOrder ? undefined : data.HashSum_EntryID_,
        DocNo: props.copyOrder ? '' : data.DocNo,
        CCY: data.CCY,
        DocDate: props.copyOrder ? props.OpenDay : LKDate.from(data.DocDate).toString(),
        DebitAccNo: data.DebitAcc,
        DebitAccID: data.DebitAccID,
        DebitAccHash: data.HashSum_DebitAccID_,
        DebitTitleUNI: data.DebitAccTitleUNI,
        DebitAccBalance: data.BalanceDebit,
        CreditAccNo: data.CreditAcc,
        CreditAccID: data.CreditAccID,
        CreditAccHash: data.HashSum_CreditAccID_,
        CreditTitleUNI: data.CreditAccTitleUNI,
        CreditAccBalance: data.BalanceCredit,
        Amount: props.copyOrder ? 0 : data.Amount,
        OpCodeID: data.OpCodeID,
        Comment: data.Comment,
        action: props.copyOrder ? 'add' : 'edit', // request action to edit order
      }),
    destroy: () => destroyAccEntryInitialFields(),
  }),

  reduxFormContainer,
)
